import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { useTranslation } from "react-i18next";

function Information() {
  const { t } = useTranslation();
  return (
    <MKBox component="section" py={10} sx={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        {/* Section Title */}
        <MKTypography variant="h2" color="dark" textAlign="center" mb={2}>
          {t("services.subtitle")}
          {/* Our Services & Insights */}
        </MKTypography>
        <MKTypography variant="body1" color="text" textAlign="center" mb={6}>
          {t("services.subtitleDescription")}
          {/* Discover how we can help you with our wide range of services aknd expertise. */}
        </MKTypography>

        {/* Main Content Row */}
        <Grid container spacing={4} alignItems="center">
          {/* Info Cards */}
          <Grid item xs={12} md={7}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <DefaultInfoCard
                  icon="public"
                  title={t("services.bankruptcy.name")}
                  description={t("services.bankruptcy.description")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DefaultInfoCard
                  icon="payments"
                  title={t("services.LivingTrust.name")}
                  description={t("services.LivingTrust.description")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DefaultInfoCard
                  icon="apps"
                  title={t("services.Refinance.name")}
                  description={t("services.Refinance.description")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DefaultInfoCard
                  icon="3p"
                  title={t("services.BuyAndSell.name")}
                  description={t("services.BuyAndSell.description")}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Image and Highlight */}
          <Grid item xs={12} md={5}>
            <MKBox
              component="img"
              src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
              alt="Service Highlight"
              width="100%"
              borderRadius="lg"
              mb={2}
              sx={{ boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}
            />
            <MKTypography variant="h5" color="dark" mb={1}>
              {t("services.whyChooseUs.highlightTitle")}
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={2}>
              {t("services.whyChooseUs.highlightText")}
            </MKTypography>
          </Grid>
        </Grid>

        {/* Feature Highlights Row */}
        <Grid container spacing={4} mt={6}>
          <Grid item xs={12} md={4}>
            <MKBox textAlign="center">
              <MKBox
                component="img"
                src="https://img.icons8.com/color/96/000000/checked-2--v2.png"
                alt="Feature 1"
                width={64}
                mb={2}
              />
              <MKTypography variant="h6" color="dark" mb={1}>
                {t("services.features.trustedExperts.title")}
              </MKTypography>
              <MKTypography variant="body2" color="text">
                {t("services.features.trustedExperts.description")}
              </MKTypography>
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MKBox textAlign="center">
              <MKBox
                component="img"
                src="https://img.icons8.com/color/96/000000/handshake.png"
                alt="Feature 2"
                width={64}
                mb={2}
              />
              <MKTypography variant="h6" color="dark" mb={1}>
                {t("services.features.personalizedSolutions.title")}
              </MKTypography>
              <MKTypography variant="body2" color="text">
                {t("services.features.personalizedSolutions.description")}
              </MKTypography>
            </MKBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MKBox textAlign="center">
              <MKBox
                component="img"
                src="https://img.icons8.com/color/96/000000/rocket--v2.png"
                alt="Feature 3"
                width={64}
                mb={2}
              />
              <MKTypography variant="h6" color="dark" mb={1}>
                {t("services.features.provenResults.title")}
              </MKTypography>
              <MKTypography variant="body2" color="text">
                {t("services.features.provenResults.description")}
              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
